import request from '@/utils/request'

/**
 * 获取任务命令列表
 * @param {*} data
 */
function getBatchRemoteSettingPageList(data) {
  return request({
    url: '/batchremotesetting/getBatchRemoteSettingPageList',
    method: 'post',
    data
  })
}

/**
 * 获取任务命令列表
 * @param {*} data
 */
function getBatchRemoteSettingPageListLock(data) {
  return request({
		url: "/lockCar/getBatchRemoteSettingDetailsPageList",
		method: "post",
		data,
	});
}

/**
 * 查看列表单条命令包参数
 * @param {*} params
 */
function getCommandParamById(params) {
  return request({
    url: '/batchremotesetting/getCommandParamById',
    method: 'get',
    params
  })
}

/**
 * 查看任务详情
 * @param {*} params
 */
function getBatchRemoteSettingDetailsPageList(data) {
  return request({
    url: '/batchremotesetting/getBatchRemoteSettingDetailsPageList',
    method: 'post',
    data
  })
}

/**
 * 获取命令包列表
 * @param {*} params
 */
function getCommandPacketPageList(data) {
  return request({
    url: '/batchremotesetting/getCommandPacketPageList',
    method: 'post',
    data
  })
}

/**
 * 获取命令包数目
 * @param {*} params
 */
function getParamCount(params) {
  return request({
    url: '/batchremotesetting/getParamCount',
    method: 'get',
    params
  })
}

/**
 * 添加任务
 * @param {*} params
 */
function createCommond(data) {
  return request({
    url: '/batchremotesetting/create',
    method: 'post',
    data
  })
}

/**
 * 导出任务详情
 * @param {*} data 
 */
function exportTask(data){
  return request({
    url: '/batchremotesetting/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

/**
 * 选择车辆终端列表
 * @param {*} data 
 */
function getTerminalPageList(data) {
  return request({
    url: '/batchremotesetting/getTerminalPageList',
    method: 'post',
    data
  })
}
/**
 * 撤销命令
 */
function cancelCommond(params) {
  return request({
    url: '/batchremotesetting/cancel',
    method: 'get',
    params
  })
}

/**
 * 一次性批量撤销命令
 * @param {*} params
 */
function cancelBatches(params) {
  return request({
    url: '/batchremotesetting/cancelBatches',
    method: 'get',
    params
  })
}

/**
 * 有选择性的批量撤销
 * @param {*} params
 */
function cancelList(data) {
  return request({
    url: '/batchremotesetting/cancelList',
    method: 'post',
    data
  })
}

/**
 * 有选择性的批量撤销
 * @param {*} params
 */
function getCommandParam() {
  return request({
    url: '/batchremotesetting/getCommandParam',
    method: 'get'
  })
}
/**
 * 获取命令文件历史版本
 * @param {*} params
 */
function getHistoricalVersion() {
  return request({
    url: '/batchremotesetting/getHistoricalVersion',
    method: 'get'
  })
}

/**
 * 获取命令文件历史版本
 * @param {*} params
 */
function getUpgrade() {
  return request({
    url: '/batchremotesetting/getUpgrade',
    method: 'get'
  })
}
/**
 * 获取下发命令终端的barcode
 */
function getBarcodePageList(data){
  return request({
    url:'/batchremotesetting/getBarcodeList',
    method:'post',
    data
  })
}
/**
 * 获取obd对应的命令名
 */
function getPacknamePageList(data){
  return request({
    url:'/batchremotesetting/getPacknameList',
    method:'post',
    data
  })
}

export {
  getBatchRemoteSettingPageList,
  getCommandParamById,
  getBatchRemoteSettingDetailsPageList,
  getBatchRemoteSettingPageListLock,
  getCommandPacketPageList,
  createCommond,
  getParamCount,
  exportTask,
  getTerminalPageList,
  cancelCommond,
  cancelBatches,
  cancelList,
  getCommandParam,
  getHistoricalVersion,
  getUpgrade,
  getBarcodePageList,
  getPacknamePageList
}